export enum checkoutMethodsOrders {
  gateways = "gateways",
  card = "card",
}
